import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocaleDatePipe } from '@app/pipes/locale-date.pipe';
import { Store } from '@ngrx/store';
import { _, TranslatePipe } from '@ngx-translate/core';
import type { AppState } from '@reducers/interfaces';
import { selectCanViewEmployeeContracts } from '@reducers/orm/permission/permission.selectors';

import { DecisionListWidgetComponent } from '../decision-list-widget/decision-list-widget.component';
import { useDecisionList } from '../decision-list-widget/use-decision-list';
import { toContractRenewalRow } from './contract-renewal-row.helper';
import { ContractRenewalsApiService } from './contract-renewals-api.service';

@Component({
  selector: 'contract-renewals-widget',
  templateUrl: './contract-renewals-widget.component.html',
  imports: [DecisionListWidgetComponent, TranslatePipe, LocaleDatePipe, RouterLink],
})
export class ContractRenewalsWidgetComponent {
  #api = inject(ContractRenewalsApiService);

  #canViewEmployeeContracts = inject<Store<AppState>>(Store).selectSignal(selectCanViewEmployeeContracts);

  list = useDecisionList({
    load: () => this.#api.list(),
    toRows: (renewals) =>
      renewals.rows.map((renewal) => toContractRenewalRow(renewal, this.#canViewEmployeeContracts())),
  });

  badgeLabel = computed(() => (this.list.count() ? _('[count] upcoming') : _('None upcoming')));
}
